import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { DashboardCard } from '../types';
import type { UserMeta } from '@api/Entities/User/UserMeta';
import { toggleInArray } from '@app/Utilities/Array';

type DashboardSettingsFormValues = {
  dashboardCards?: Array<DashboardCard>;
};

type DashboardSettingsFormProps = {
  initialValues?: DashboardSettingsFormValues;
  onSave?: (values: DashboardSettingsFormValues) => Promise<UserMeta>;
};

export const SettingsForm = ({ initialValues, onSave }: DashboardSettingsFormProps) => {
  const { t } = useTranslation();

  const [formValues, setFormValues] = React.useState<DashboardSettingsFormValues>(initialValues);
  const [formLoading, setFormLoading] = React.useState<boolean>(false);

  const toggleDashboardCards = (value: DashboardCard) => {
    setFormValues((prev) => {
      return {
        ...prev,
        dashboardCards: toggleInArray(prev.dashboardCards, value),
      };
    });
  };

  const submitForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormLoading(true);

    if (onSave) {
      onSave(formValues).then(() => {
        setFormLoading(false);
      });
    }
  };

  return (
    <Form onSubmit={submitForm}>
      <Form.Group>
        <Form.Label>{t('dashboard.settingsModal.cardsLabel')}</Form.Label>

        <div>
          {Object.values(DashboardCard).map((value) => (
            <Form.Check
              key={value}
              type="checkbox"
              label={t(`common.${value}`)}
              name="cardTypes"
              checked={formValues.dashboardCards && formValues.dashboardCards.includes(value)}
              onChange={() => toggleDashboardCards(value)}
            />
          ))}
        </div>
      </Form.Group>

      <Button type="submit">
        {formLoading ? (
          <>
            <FontAwesomeIcon icon={faSpinner} spin /> {t('common.saveChangesLoading')}
          </>
        ) : (
          t('common.saveChanges')
        )}
      </Button>
    </Form>
  );
};
